import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';

const SurveyThankYou = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-white dark:bg-black flex items-center justify-center p-6">
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="max-w-lg w-full text-center"
      >
        {/* Success Icon */}
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="w-20 h-20 mx-auto mb-8 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center"
        >
          <svg className="w-10 h-10 text-green-600 dark:text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
          </svg>
        </motion.div>

        {/* Main Message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
          className="space-y-4"
        >
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 dark:text-white tracking-tight">
            Thank You!
          </h1>
          <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed">
            Your feedback has been submitted successfully. We truly appreciate you taking the time to share your thoughts with us.
          </p>
        </motion.div>

        {/* Additional Message */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
          className="mt-8 p-6 bg-gray-50 dark:bg-[#1A1A1A] rounded-xl"
        >
          <p className="text-gray-700 dark:text-gray-300">
            Your feedback helps us improve our services and deliver even better experiences for future clients. 
            We'll review your responses and may reach out if we have any follow-up questions.
          </p>
        </motion.div>

        {/* Action Buttons */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
          className="mt-8 space-y-4"
        >
          <motion.button
            onClick={() => navigate('/')}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            className="w-full py-3 px-6 bg-brand hover:bg-brand-hover text-black font-medium rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            Back to Home
          </motion.button>
          
          <p className="text-sm text-gray-500 dark:text-gray-400">
            If you have any additional questions or concerns, feel free to contact us directly.
          </p>
        </motion.div>

        {/* Decorative Elements */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.6 }}
          className="mt-12 flex justify-center space-x-2"
        >
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              animate={{ 
                scale: [1, 1.2, 1],
                opacity: [0.5, 1, 0.5]
              }}
              transition={{ 
                duration: 2,
                repeat: Infinity,
                delay: i * 0.2
              }}
              className="w-2 h-2 bg-brand rounded-full"
            />
          ))}
        </motion.div>
      </motion.div>
    </div>
  );
};

export default SurveyThankYou; 